import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
	container: {
		columnCount: 2,
		columnGap: '4rem',
		widows: 3,
		orphans: 3,
		[theme.breakpoints.down("sm") ]: {
			columnGap: '2rem'
		},
		[theme.breakpoints.down("xs") ]: {
			columnCount: 1
		}
	}
}));

const TextColumns = props => {
	const classes = useStyles();
	return (
		<div className={classes.container}>{props.children}</div>
	);
};

export default TextColumns;
